/* eslint-disable import/prefer-default-export */
import { makeEntityScaffold } from '@classpass/saga-tools';
export var leaderboardJoinClass = makeEntityScaffold('SAGA.API.LEADERBOARD_JOIN_CLASS', function (client, alias) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return client.leaderboard.joinClass(alias, options);
}, {
  defaultKey: 1
});
export var leaderboardLeaveClass = makeEntityScaffold('SAGA.API.LEADERBOARD_LEAVE_CLASS', function (client, alias) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return client.leaderboard.leaveClass(alias, options);
});
export var leaderboardUpdateHeartrate = makeEntityScaffold('SAGA.API.LEADERBOARD_UPDATE_HEARTRATE', function (client, classId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return client.leaderboard.updateHeartrate(classId, options);
});
export var leaderboardUpdateClientStatus = makeEntityScaffold('SAGA.API.LEADERBOARD_UPDATE_CLIENT_STATUS', function (client, alias) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return client.leaderboard.updateStatus(alias, options);
});